import { render, staticRenderFns } from "./DetalhesAdministracao.vue?vue&type=template&id=7fb6eea4&scoped=true"
import script from "./DetalhesAdministracao.vue?vue&type=script&lang=js"
export * from "./DetalhesAdministracao.vue?vue&type=script&lang=js"
import style0 from "./DetalhesAdministracao.vue?vue&type=style&index=0&id=7fb6eea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb6eea4",
  null
  
)

export default component.exports